// Event delegation on document, registered synchronously the instant this script executes -
// no DOMContentLoaded dependency at all, so there is no load-order race to lose. Earlier
// versions of this file looked up .account-trigger/.account-dropdown once at script-load time
// and bailed out permanently if they weren't in the DOM yet (this file loads as <script async>
// in sections/header.liquid, so on a heavy page - search/collection results, which load extra
// deferred modules - it could execute before the browser had parsed that far, or even before
// DOMContentLoaded had fired). Delegation instead resolves the actual trigger/dropdown elements
// only inside the click handler, at the moment of the click, by which point the DOM is always
// complete - the element merely needing to exist NOW, not "having existed when this script ran",
// removes the race entirely rather than just narrowing its window.
function setHeaderOverflow(value) {
    const headerComponentEl = document.querySelector('#header-component');
    const headerContainerEl = headerComponentEl?.querySelector('.header-new__container');
    if (headerComponentEl && headerContainerEl) {
        headerComponentEl.style.overflow = value;
        headerContainerEl.style.overflow = value;
    }
}

document.addEventListener('click', (e) => {
    if (window.innerWidth >= 1024) return;
    if (!(e.target instanceof Element)) return;

    const trigger = e.target.closest('.account-trigger');

    if (trigger) {
        const dropdown = trigger.querySelector('.account-dropdown');
        if (!dropdown || dropdown.contains(e.target)) return;

        e.preventDefault();
        dropdown.classList.toggle('is-active');
        const isExpanded = dropdown.classList.contains('is-active');
        trigger.setAttribute('aria-expanded', isExpanded);
        setHeaderOverflow(isExpanded ? 'visible' : '');
        return;
    }

    // Click outside any trigger: close whichever dropdown is currently open, if any.
    const openTrigger = document.querySelector('.account-trigger[aria-expanded="true"]');
    if (!openTrigger || openTrigger.contains(e.target)) return;

    openTrigger.querySelector('.account-dropdown')?.classList.remove('is-active');
    openTrigger.setAttribute('aria-expanded', 'false');
    setHeaderOverflow('');
});